import React from 'react';
import { DatePicker, Progress } from 'antd';
import SearchFilter from '../filters/SearchFilter';
import Main from '../../Pages/Demo/main';
import Lang from '../../lang'
import { toast } from 'react-toastify';
import { Input } from '@progress/kendo-react-inputs';
import services from '../../services';
import { Button } from '@progress/kendo-react-buttons'
import MatrixModalForm from './matrixArticleModalForm';
var moment = require('moment')

const filters = {
    Tabs: {
        Entidade: [
            {
                key: 'ivpdInstallmentNO',
                displayKey: "NparcelaIVPD",
                inputType: "text"
            },
            {
                key: 'cdInstallmentNO',
                displayKey: "NParcelaCd",
                inputType: "text"
            },
            {
                key: 'declaration',
                displayKey: "Declaracao",
                inputType: "text"
            }
        ]
    },
    checkbox: [
    ]
}

class WizardModalForm extends React.Component {
    /* Primeiro passo na acomodação da classe */

    constructor(props) {
        super(props);
        this.state = {
            data: {},
            telkikTable: "",
            Comment: '',
            moduleData: []
        }
    }

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount() {
        this.setMainState()
    }
    /* Esta função irá chamar automaticamente quando o estado da página mudar */

    componentDidUpdate(preProp) {
        if (preProp.date !== this.props.date) {
            this.setMainState()
        }
    }
    setMainState = () => {
        // console.log(this.props);

        this.setState({
            data: this.props.data ? this.props.data : {},
            moduleData: this.props.moduledata
        }, () => {
            if (this.props.tab === 'castaparc') {
                this.updatePctCasta()
            }
        });
    }

    updatePctCasta = () => {
        // para atualizar o valor da porcentagem de casta
        let data = { ...this.state.data }
        let totalCasta = 0
        if (this.state.moduleData.length > 0) {
            this.state.moduleData.map(_r => {
                totalCasta += Number(_r.pctcasta)
            })
            data['pctcasta'] = 100 - totalCasta
        }
        this.setState({
            data
        })
    }

    handleDate = (e) => {
        let data = { ...this.state.data }
        data['startDate'] = e && e._d && moment(e._d).format('MM-DD-YYYY')
        this.setState({
            data
        })
    }

    handleChange = (e) => {
        let data = { ...this.state.data }
        if (e.target.name === 'pctcasta' && (Number(e.target.value) < 0 || Number(e.target.value) > 100)) {
            toast.error("A Porcentagem nunca deve ser menor que 0 ou maior que 100")
            return;
        }
        if (!e.target.value) {
            delete data[e.target.name]
        } else
            data[e.target.name] = e.target.value;

        this.setState({
            data
        })
    }

    Submitform = () => {
        let data = { ...this.state.data }
        let error = null;
        let errors = {};

        if (this.props.moduledata) {
            let index = (this.state.moduleData).length
            let dataarray = [...this.state.moduleData];
            dataarray[index] = data;
            // console.log('this data:', data);
            if (this.props.tab == "castaparc") {
                if (!data.pctcasta || !data.codcasta || !data.idsinonimo) {
                    toast.error("Por favor, preencha os detalhes completos");
                    return
                }
                if (dataarray.filter(_ar => _ar.codcasta == data.codcasta).length > 1) {
                    toast.error("Existe um registo associado com os dados introduzidos");
                    return
                }
                if (data.pctcasta) {
                    let castasum = 0;
                    dataarray.map((_row, index) => {
                        castasum += parseInt(_row.pctcasta)
                    });
                    if (castasum > 100) {
                        toast.error("O valor total de castas não poderá ser superior a 100%")
                        return false;
                    }
                }
                // data.fatorCasta=1;
                // data.fatorDOPorto=1;

            }
            if (this.props.tab == "matrixArticle") {
                let nrartigo = Number(data.nrartigo);
                console.log(nrartigo);
                if (isNaN(nrartigo)) {
                    // if ( !(data.nrartigo > 0) || data.nrartigo=== " " ) {
                    errors.nrartigo = {
                        "nrartigo": ["Nº Artigo parte deve estar em Fração ou Inteiro"]
                    }
                }
                if (Object.keys(errors).length > 0) {
                    error = {
                        errors: errors
                    }
                    services.errorCheck.error(error);
                    return;
                }
            }


            // if (this.props.tab == "matrixArticle") {
            //     console.log("nnnnn", data.nrartigo)
            //     if (isNaN(Number(data.nrartigo)) && data.nrartigo) {
            //         toast.error("Conteúdo inválido")
            //         return
            //     } else if (!data.nrartigo) {
            //         toast.error("nrartigo parte deve estar em Fração ou Inteiro")
            //         return
            //     }
            // }
            if (!error)
                this.props.getpopUpdata(dataarray, this.props.tab);
            else
                services.errorCheck.error(error);

        } else {

            this.props.getpopUpdata(data, this.props.tab);
        }
        if (!error)
            this.props.closePopup();
    }


    /* Obter a chave do filtro do filtro personalizado */
    getFilters = () => {
        return null;
    }

    /* Para obter dados filtrados do componente de filtro personalizado  */

    handleFilter = (data) => {

    }

    handleComment = (e) => {
        this.setState({
            Comment: e.target.value
        })
    }

    handleChangeCasta = (e) => {
        let data = { ...this.state.data }
        data[e.target.name] = e.target.value;
        let Duro = {};
        let Casta = {};
        this.props.all_list.DouroPort.map((_row, index) => {
            if (parseInt(_row.duroid) === parseInt(e.target.value)) {
                Duro = _row
            }
        })
        this.props.all_list.Casta.map((_row, index) => {
            if (parseInt(_row.codcasta) === parseInt(data.codcasta)) {
                Casta = _row
            }
        })
        if (Casta.doporto == Casta.dodouro) {
            data.douroPort = Casta.doporto;
        }
        data.Estado = "A";
        data.dtact = Casta.dtact;
        data.hract = Casta.hract;
        data.usr = Casta.usr;
        data.wks = Casta.wks;
        data.idcor = Casta.idcor;
        data.idsinonimo = Duro.idsinonimo;
        data.st = Casta.st;
        data.disponivel = true;
        data.fatorDOPorto = Casta.fatorDOPorto || 1;
        data.fatorCasta = Casta.fatorCasta || 1;
        ///Not clear
        data.tipo = this.state.data.douroPort;
        data.predioarranque = "N/A";
        data.tipoha = "N/A";

        this.setState({
            data
        });
    }

    handleAuditSubmit = () => {
        if (this.props.handleAuditSubmit) {
            this.props.handleAuditSubmit(this.state.Comment)
            this.props.closePopup()
        }
    }



    /*  Para renderizar o conteúdo html da página   */

    render() {

        if (this.props.tab === "castaparc" ) {
            return (
                <div className="modal-content">
                    <div className="modal-header">
                        <h4 className="modal-title pl-0">Gerir Castas</h4>
                        <Button onClick={() => this.Submitform()} primary={true} className="btn-ivdp-primary btn-sm text-uppercase mr-3">Guardar</Button>
                        <Button onClick={() => this.props.closePopup()} className="remoove cursor-pointer mr-2 k-primary btn-ivdp-secondary btn-theme">Cancelar</Button>
                    </div>
                    <div className="modal-body">
                        <div className="details">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="input-box active-grey mb-2">
                                        {/* <label className="input-label">Casta</label>
                                 <input type="text" className="input-1" placeholder="Casta" />
                                */
                                        }
                                        <label className="input-label">Casta</label>
                                        <select className="custome-drop-down" value={this.state.data.codcasta || ""} name="codcasta" onChange={(e) => this.handleChangeCasta(e)}>
                                            <option value="">Selecione casta </option>
                                            {
                                                this.props.all_list.Casta &&
                                                this.props.all_list.Casta.map((_row, index) => (
                                                    <option value={_row.codcasta}>{_row.descasta}</option>
                                                ))
                                            }
                                        </select>
                                        {/* <Input
                                    type="text"
                                    style={{ width: "100%"}}
                                    className="input-1"
                                    name="casta" 
                                    value={this.state.data.casta || ""}
                                    label="Casta"
                                    onChange={(e)=>this.handleChange(e)}
                                />  */
                                        }
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <label>Tipo Casta</label>
                                    <div className="input-box active-grey">
                                        <span>
                                            {
                                                this.state.data.douroPort == 'N' ?
                                                    <strong>Douro : N</strong>
                                                    :
                                                    this.state.data.douroPort == 'S' ?
                                                        <strong>Porto : S</strong>
                                                        :
                                                        ''
                                            }
                                        </span>
                                        {/* <select className="custome-drop-down" value={this.state.data.douroPort || ""} name="douroPort" onChange={(e) => this.handleChange(e)}>
                                            <option value="">Selecione Tipo Casta </option>
                                            {
                                                this.props.all_list.DouroPort &&
                                                this.props.all_list.DouroPort.map((_row, index) => (
                                                    <option value={_row.duroid}>{_row.desduro}</option>
                                                ))
                                            }
                                        </select> */}
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="input-box active-grey mb-2">
                                        <label className="input-label">Cor</label>
                                        <select className="custome-drop-down" value={this.state.data.idcor || ""} name="idcor" onChange={(e) => this.handleChange(e)}>
                                            <option disabled value="">Selecione Cor</option>
                                            {
                                                this.props.all_list.colors &&
                                                this.props.all_list.colors.map((_row, index) => (
                                                    <option value={_row.idcor} disabled>{_row.descor}</option>
                                                ))
                                            }
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="input-box active-grey mb-2">
                                        <label className="input-label">Sinónimos</label>
                                        <select className="custome-drop-down" value={this.state.data.idsinonimo || ""} name="idsinonimo" onChange={(e) => this.handleChange(e)}>
                                            <option value="">Selecione Sinónimos </option>
                                            {
                                                this.props.all_list.Sinonimo &&
                                                this.props.all_list.Sinonimo.map((_row, index) => (
                                                    <option value={_row.idsinonimo}>{_row.descasta}</option>
                                                ))
                                            }
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="input-box active-grey mb-2">
                                        {/* <label className="input-label">Percentagem </label>
                                 <input type="text" className="input-1" placeholder="Enter Percentagem" />  */
                                        }
                                        <Input
                                            type="number"
                                            style={{ width: "100%" }}
                                            min={0}
                                            className="input-1"
                                            name="pctcasta"
                                            value={this.state.data.pctcasta || ""}
                                            label="Percentagem"
                                            onChange={(e) => this.handleChange(e)}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="input-box active-grey mb-2">
                                        {/* <label className="input-label">Fator Castas </label>
                                 <input type="text" className="input-1" placeholder="Enter Fator Castas" />  */
                                        }
                                        <Input
                                            type="number"
                                            style={{ width: "100%" }}
                                            className="input-1"
                                            name="fatorCasta"
                                            readOnly={true}
                                            value={this.state.data.fatorCasta || 1}
                                            label="Fator Castas"
                                            onChange={(e) => this.handleChange(e)}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="input-box active-grey mb-2">
                                        {/* <label className="input-label">Fator Do Porto </label>
                                 <input type="text" className="input-1" placeholder="Enter Fator Do Porto" />  */
                                        }
                                        <Input
                                            type="number"
                                            style={{ width: "100%" }}
                                            className="input-1"
                                            name="fatorDOPorto"
                                            label="Fator DO Porto"
                                            readOnly={true}
                                            value={this.state.data.fatorDOPorto || 1}
                                            onChange={(e) => this.handleChange(e)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
       
        // else if (this.props.tab === 'legalFramework') {
        //     return (
        //         <MatrixModalForm data={this.state.data} />
        //     )
        // }
        else if (this.props.tab === 'Registo') {
            return (
                <div className="modal-content">
                    <div className="modal-header">
                        <h4 className="modal-title pl-0">Registo de alterações</h4>
                        <Button primary={true} onClick={() => this.handleAuditSubmit()} className="btn-ivdp-primary btn-sm text-uppercase mr-3">Guardar</Button>
                        <Button onClick={() => this.props.closePopup()} className="remoove cursor-pointer mr-2 k-primary btn-ivdp-secondary btn-theme">Cancelar</Button>
                    </div>
                    <div className="modal-body">
                        <div className="details">
                            <div className="row">
                                <div className="col-12">
                                    <div className="form-group">
                                        <div className="input-box active-grey">
                                            <label className="input-label">Observações</label>
                                            <textarea onChange={(e) => this.handleComment(e)} className="form-control heigh-auto mt-2" rows="4" placeholder="Entrar Observações"></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <h3>Ultima alterações</h3>
                            <div className="row">
                                <div className="col-md-6">
                                    <p>Versao</p>
                                    <h3>4</h3>
                                </div>
                                <div className="col-md-6">
                                    <p>Movimento</p>
                                    <h3>Alterações</h3>
                                </div>
                                <div className="col-md-12">
                                    <p>Observações</p>
                                    <h3>{this.state.data[Lang.langCheck.langRequest("Comment")] ? this.state.data[Lang.langCheck.langRequest("Comment")] : "N/A"}</h3>
                                </div>
                                <div className="col-md-12">
                                    <p>Origem</p>
                                    <h3>n/a</h3>
                                </div>
                                <div className="col-md-12">
                                    <p>Processo</p>
                                    <h3>13134</h3>
                                </div>
                                <div className="col-md-6">
                                    <p>Ano</p>
                                    <h3>2014</h3>
                                </div>
                                <div className="col-md-6">
                                    <p>Eencontro</p>
                                    <h3>{this.state.data[Lang.langCheck.langRequest("Date")]}</h3>
                                </div>
                                <div className="col-md-12">
                                    <p>Utilizador</p>
                                    <h3>{this.state.data[Lang.langCheck.langRequest("Username")]}</h3>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            )
        } else if (this.props.tab === 'matrixArticle') {
            return (
                <div className="modal-content">
                    <div className="modal-header">
                        <h4 className="modal-title pl-0">Inserir Artigo Matricial</h4>
                        <Button primary={true} onClick={() => this.Submitform()} className="btn-ivdp-primary btn-sm text-uppercase mr-3">Guardar</Button>
                        <Button onClick={() => this.props.closePopup()} className="remoove cursor-pointer mr-2 k-primary btn-ivdp-secondary btn-theme">Cancelar</Button>
                    </div>
                    <div className="modal-body">
                        <div className="details row">
                            <div className="col-md-6">
                                <div className="input-box active-grey mb-2">
                                    <Input
                                        type="text"
                                        style={{ width: "100%" }}
                                        className="input-1"
                                        name="nrartigo"
                                        value={this.state.data.nrartigo || ""}
                                        label="Nº Artigo"
                                        onChange={(e) => this.handleChange(e)}
                                    />
                                </div>
                            </div>


                            <div className="col-md-6">
                                <div className="input-box active-grey mb-2">
                                    <Input
                                        type="text"
                                        style={{ width: "100%" }}
                                        className="input-1"
                                        name="fraccao"
                                        value={this.state.data.fraccao || ""}
                                        label="Fração"
                                        onChange={(e) => this.handleChange(e)}
                                    />
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            )
        }
    }
}

export default WizardModalForm;